import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getVillaViews } from 'checkout/selectors/view/villa'
import getHotelEncryptedMargin from 'loyalty/lib/margin/getHotelEncryptedMargin'
import getLoyaltyEarnKey from 'loyalty/lib/pointsCalculation/earnKey/getLoyaltyEarnKey'

const getCheckoutVillasPointsCalculationRequests = createSelector(
  (state: App.State) => getVillaViews(state),
  (villaViews): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!villaViews.hasRequiredData) return EmptyArray

    return villaViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => ({
      price: itemView.totals.price,
      memberPrice: itemView.totals.memberPrice,
      loyaltyProductType: 'rental',
      offerId: itemView.offer.id,
      packageId: itemView.package.id,
      mx: getHotelEncryptedMargin(itemView.offer.type, itemView.package),
      itemId: itemView.item.itemId,
      earnKey: getLoyaltyEarnKey({
        loyaltyProductType: 'rental',
        options: {
          propertyCountryCode: itemView.offer.property.geoData.countryCode,
          propertyStateProvince: itemView.offer.property.geoData.administrativeAreaLevel1 ?? undefined,
        },
      }),
      nights: itemView.item.duration,
      orderId: 'orderId' in itemView.item ? itemView.item.orderId : undefined,
      orderItemId: 'orderItemId' in itemView.item ? itemView.item.orderItemId : undefined,
    }))
  },
)

export default getCheckoutVillasPointsCalculationRequests
